/*
 * @Author: zyt
 * @Title: 公共方法
 * @Date: 2020-06-23 14:55:15
 * @LastEditTime: 2020-08-18 18:09:18
 */
//跳转菜单列表
export function menuListGet(){
    return [
        'testManual', //考试文档
        'mkfDetection', //系统检测
        'youXunCheck', //登录优巡
        'signCommitment',//手机签署承诺书
        'examination', //开始考试
    ]
}
//判断令牌是否过期
export  function ValidityOfIdentity(expiry){
    if(+new Date() >= expiry){
        return true;
    }else{
        return false;
    }
}
export function isObjNoKong(obj) {
    let flag = false;
    for(var prop in obj){
        if(obj[prop]){
            flag = true;
            break;
        }
    }
    if(flag){ return true}
    else{return false}
  }
export function empty(obj){
    Object.keys(obj).forEach(key => (obj[key] = ''));
    return obj
}
export function editorValue(val){
    return obj
}
export function getImgUrl(str){
    var reg = new RegExp("(<img.*src=\"\.*?\>)");
    var imgs = str.match(reg);
    var re = /(http|https)([^"]*)/g;
    return imgs[0].match(re)//路径数组
}
export function getVideoUrl(str){
    var reg = new RegExp("(<iframe.*src=\"\.*?\>)");
    var videos = str.match(reg);
    var re = /(http|https)([^"]*)/g;
    return videos[0].match(re)//路径数组
}
export function getAudioUrl(str){
    var reg = new RegExp("(<audio.*src=\"\.*?\>)");
    var audios = str.match(reg);
    var re = /(http|https)([^"]*)/g;
    return audios[0].match(re)//路径数组
}
export function jube(onceStr,t){
    var index = onceStr.indexOf(t);
    var num = 0; 
    var indexArr = []
    while(index !== -1) {
        indexArr.push(index)
        num++;
        index = onceStr.indexOf(t,index + 1);
    }
    return indexArr
}
/**
 * @description: 数据处理
 * @param {type} 
 * @return {type} "题目{%}"
 */
export function getText(str){
   if(!str)
   return ''
    let [imgUrlArr,videoUrlArr,audioUrlArr] = [[],[],[]]
    if(str.indexOf("<img") != -1)
    imgUrlArr = this.getImgUrl(str)
    if(str.indexOf("<iframe") != -1)
    videoUrlArr = this.getVideoUrl(str)
    if(str.indexOf("<audio") != -1)
    audioUrlArr = this.getAudioUrl(str)
    str=str.replace(/<\s?img[^>]*>/gi,'IMAGES')
    str=str.replace(/<\s?iframe[^>]*[></iframe>]/gi,'VIDEO')
    str=str.replace(/<\s?audio[^>]*[></audio>]/gi,'AUDIO')
    var onceStr=str.replace(/<.*?>/g,'');
    let iIndex = this.jube(onceStr,'IMAGES')
    let vIndex = this.jube(onceStr,'VIDEO')
    let aIndex = this.jube(onceStr,'AUDIO')
    var elements = [iIndex,vIndex,aIndex]
    var result = elements.flat().sort((a,b)=>a-b)
    var elArr = []
    let [iNum,vNum,aNum] = [0,0,0]
    for(let c=0;c<result.length;c++){
        if(iIndex.length>0&&iIndex.indexOf(result[c])!=-1){
            elArr.push({
                'type':'img',
                'content':imgUrlArr[iNum]
            })
            iNum++;
        }else if(vIndex.length>0&&vIndex.indexOf(result[c])!=-1){
            elArr.push({
                'type':'video',
                'content':videoUrlArr[vNum]
            })
            vNum++;
        }else if(aIndex.length>0&&aIndex.indexOf(result[c])!=-1){
            elArr.push({
                'type':'audio',
                'content':audioUrlArr[aNum]
            })
            aNum++;
        }
    }
    let results = {
        'msg':onceStr.replace(/(VIDEO|IMAGES|AUDIO)/g,'{%}'),
        'element':elArr
    }
    results = JSON.stringify(results)
    return results
}
/**
 * @description: 数据还原
 * @param {type} 
 * @return {type} 
 */
export function dealText(str){
    if(JSON.stringify(str)=='{}'||JSON.stringify(str.msg)=='{}'||str==''||str==null)
    return ''
    str = JSON.parse(str)
    let down = this.jube(str.msg,'{%}');
    for(let i=0;i<down.length;i++){
        if(str.element[i].type=='img'){
            str.msg = str.msg.replace('{%}','<div class="tableimg"><img src="'+str.element[i].content+'"></div>')
        }else if(str.element[i].type=='video'){
            str.msg = str.msg.replace('{%}','<iframe class="ql-video" frameborder="0" allowfullscreen="true" src="'+str.element[i].content+'" controls="controls"></iframe>')
        }else if(str.element[i].type=='audio'){
            str.msg = str.msg.replace('{%}','<audio src="'+str.element[i].content+'" controls="true" controlslist="nodownload" id="voice"></audio>')
        }
    }
    return str.msg;
}
export function dealImg(str){
    return '<div class="tableimg"><img src="'+str+'"></div>'
}
export function dealAudio(str){
    return '<audio src="'+str+'" controls="true" controlslist="nodownload" id="voice"></audio>'
}
export function dealVideo(str){
    return '<iframe class="ql-video" frameborder="0" allowScriptAccess="sameDomain" allowfullscreen="true" src="'+str+'"></iframe>'
}
export function json_P(str){
    return JSON.parse(str)
}
export function  deepClone2(obj) {
    var _obj = JSON.stringify(obj),
      objClone = JSON.parse(_obj);
    return objClone;
  }
export function checkHtml(htmlStr) {
    var  reg = /<[^>]+>/g;
    return reg.test(htmlStr);
}
/**
 * @description: 时间戳转化为正常时间格式
 * @param {type} 类型
 * @return {type} string
 */
export function fmtDate (date, fmt){
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
};

export function getImageFileFromUrl(url, imageName) {
    
    // imageName一定要带上后缀
    let p = new Promise((resolve, reject) => {
        var blob = null;
        var xhr = new XMLHttpRequest(); 
        xhr.open("GET", url);
        xhr.setRequestHeader('Accept', 'image/jpeg');
        xhr.responseType = "blob";
        xhr.onload = () => {
            blob = xhr.response;
            let imgFile = new File([blob], imageName, {type: 'image/jpeg'});
            resolve(imgFile);
        };
        xhr.send();
    });
    return p;
}  
export function  foo_judge(type,str){
    if(this.checkHtml(str)&&type=='audio'){
        return this.getText(str)
    }else if(!this.checkHtml(str)&&type=='audio'){
        return this.getAudioUrl(str)
    }else if(this.checkHtml(str)&&type=='video'){
        return this.getText(str)
    }else if(!this.checkHtml(str)&&type=='video'){
        return this.getVideoUrl(str)
    }else if(this.checkHtml(str)&&type=='img'){
        return this.getText(str)
    }else if(!this.checkHtml(str)&&type=='img'){
        return this.getImgUrl(str)
    }
}
export function formatDateTime(date){
    //date是传入的时间
    let d = new Date(date);
    let month = (d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : (d.getMonth() + 1);
    let day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
    let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
    let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
    let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
    // let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
    let times=d.getFullYear() + '-' + month + '-' + day;
    return times
};
export function intToChinese ( num ) {
    var N = [
        "零", "一", "二", "三", "四", "五", "六", "七", "八", "九",'十'
    ];
    var str = num.toString();
    var len = num.toString().length;
    var C_Num = [];
    if(len<2){
        C_Num.push(N[num]);
    }else if(len<3){
        let a = N[Number(str[len-1])]
        a = a==N[0]? '':a
        let b = N[N.length-1]+a
        C_Num.push(b);
    }else{
        return num
    }
    return C_Num.join('')
}
//剔除非上架数据
export function delNoshelves (datas){
    return datas.filter(item=>item.status == 1)
} 
//版本号
export function isVersion(str) {
    const reg = /^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/
    return reg.test(str)
}
//小数 <=> %
export function toPercent(point){
    var str=Number(point*100).toFixed(1);
    return str;
}
export function getFileSize(fileByte) {
    var fileSizeByte = fileByte;
    var fileSizeMsg = "";
    if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB";
    else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB";
    else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB";
    else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    else fileSizeMsg = "文件超过1TB";
    return fileSizeMsg;
}
/**
     * oss 保留下数位
     * type 取整方式
     */
export function unsingNumber(num,type,oss){
    var cce = 100; 
    var data = '';
    switch(oss){
        case 1:
            cce = 10;
            break;
        case 2:
            cce = 100;
            break;
        case 3:
            cce = 1000;
            break;
        case 4:
            cce = 10000;
            break;
        case 5:
            cce = 100000;
            break;
        case 6:
            cce = 1000000;
            break;
        case 7:
            cce = 10000000;
            break;
        case 8:
            cce = 100000000;
            break;
        case 9:
            cce = 1000000000;
            break;
        default:
            cce = 100;
            break;
    }
    switch(type){
        case 'floor':
            //向下取整
            data =  Math.floor(num * cce) / cce
            break;
        case 'round':
            //四舍五入
            data =  Math.round(num * cce) / cce
            if(oss==2){
                data = fill0(data)
            }
            break;
        case 'ceil':
            //向上取整
            data =  Math.ceil(num * cce) / cce
            if(oss==2){
                data = fill0(data)
            }
            break;
        default:
            break;
    }
    return data
};
/**
 * @description: 2020-08-11T03:19:54.000 0000转化为时间戳
 * @param {type} 例： 2020-08-11T03:19:54.000
 * @return {type} string
 */
export function timeStamp(tiem) {
    return new Date(new Date(tiem).toJSON()).getTime()
}
export function fmtCountdown(micro_second) {
    var second = Math.floor(micro_second);
    var day = Math.floor(second / 3600 / 24);
    var hr = Math.floor(second / 3600 % 24);
    hr = hr < 10? ('0'+hr):hr;
    var min = Math.floor(second / 60 % 60);
    min = min < 10? ('0' + min):min;
    var sec = Math.floor(second % 60);
    sec = sec < 10? ('0' + sec):sec;
    if(day > 0) {
      return day + '天' + hr + ":" + min+':'+sec; 
    } else {
      return hr + ":" + min+':' + sec;
    }
}
/**
 * @description: 2020-02-11T12:24:18.000+0000 格式转化为 2020-02-11 12:24:18
 * @param {type} 2020-02-11T12:24:18.000+0000
 * @return {type} string
 */
export function renderTime(date) {
    var dateee = new Date(date).toJSON();
    return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
}
/**
 * @description:13位置时间戳之差输出 例：2分26秒 
 * @param {type} 时间戳之差
 * @return {type} String
 */
export function getRemainderTime (startTime){
    var runTime = parseInt(startTime / 1000);
    var year = Math.floor(runTime / 86400 / 365);
    runTime = runTime % (86400 * 365);
    var month = Math.floor(runTime / 86400 / 30);
    runTime = runTime % (86400 * 30);
    var day = Math.floor(runTime / 86400);
    runTime = runTime % 86400;
    var hour = Math.floor(runTime / 3600);
    runTime = runTime % 3600;
    var minute = Math.floor(runTime / 60);
    runTime = runTime % 60;
    var second = runTime;
    //year+'年'+month+'月'+day+'日'+hour+'小时'+minute+'分钟'+second+'秒';
    if(year > 0) {
        　return year+'年'+month+'月'+day+'天';
    } else if(month > 0) {
        　return month+'月'+day+'天'+hour+'时';
    } else if(day > 0) {
        　return day+'天'+hour+'时'+minute+'分';
    } else if(hour > 0) {
        　return hour+'时'+judgeMin0(minute,'分');
    } else if(minute > 0) {
        　return minute+'分'+judgeMin0(second,'秒');
    } else if(second > 0) {
        　return second+'秒';
    }
}
export function judgeMin0 (val,fm){
    return val? `${val}${fm}`:`${val+1}${fm}`
}
export function testBW(fn) {
    var startTime, endTime, fileSize;
    var xhr = new XMLHttpRequest();
    xhr.timeout=30000;
    xhr.onerror=function (){
        console.log('onerror');
    }
    xhr.onreadystatechange =function(){
        if(xhr.readyState === 2){
            startTime = Date.now();
        }
        if (xhr.readyState === 4) {
            endTime = Date.now();
            fileSize = xhr.responseText.length;
            var speed = fileSize  / ((endTime - startTime)/1000) / 1024;
            fn && fn(Math.floor(speed)||0)
        }
        if(xhr.status === 200) {
            endTime = Date.now();
            fileSize = xhr.responseText.length;
            var speed = fileSize  / ((endTime - startTime)/1000) / 1024;
            // fn && fn(Math.floor(speed)||0)
        }
    }
    xhr.open("GET", "http://wangsu3s.acc5.com/ping.jpg?rnd=" + Math.random(), true);
    xhr.send();
}
export function topicTypeFilters(val){
    return val==10? '标准选择题':val==20? '听音填写':val==30? '视唱':val==40? '文字':''; 
}
export function swapItems(arr, index1, index2) {
    let item = arr.splice(index1, 1)
    arr.splice(index2, 0, item[0])
    return arr;
}

export function inputNumber2(num){
    var str = num
    var len1 = str.substr(0, 1)
    var len2 = str.substr(1, 1)
    //如果第一位是0，第二位不是点，就用数字把点替换掉
    if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1)
    }
    //第一位不能是.
    if (len1 == ".") {
        str = ""
    }
    //限制只能输入一个小数点
    if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1)
        if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
        }
    }
    //正则替换
    str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
    str = str.replace(/\.\d\d\d$/,'') // 小数点后只能输两位
    return str
}
//str:原始字符串，index,开始位置,changeStr，改变后的字
export function changeStr(str,index,changeStr){
    return str.substr(0, index) + changeStr+ str.substr(index + changeStr.length);
}
// 反转义
// 放在getText 题目转译{%}之后执行
export function HTMLDecode(s) {
    if   (s==null||s=='') return   "";   
    s = s.replaceAll("&amp;","&");   
    s = s.replaceAll("&lt;","<");   
    s = s.replaceAll("&gt;",">");   
    s = s.replaceAll("&nbsp;","   ");   
    s = s.replaceAll("<br/>","\n");   
    s = s.replaceAll("&#39","'");   
    return   s;   
}
export function acgType(s) {
    // 1=试听练耳A 2=试听练耳B 3=试听练耳C 4=乐理
    let type;
    switch(s){
        case 'A':
            type = 1;
            break;
        case 'B':
            type = 2;
            break;
        case 'C':
            type = 3;
            break;
        case '乐理':
            type = 4;
            break;
        default:
            type = '';
            break;
    }
    return type;
}
export function mottoClone (obj) {//深拷贝
    if (obj === null || typeof obj !== 'object') return obj;
    if (obj instanceof Boolean) return new Boolean(obj.valueOf());
    if (obj instanceof Number) return new Number(obj.valueOf());
    if (obj instanceof String) return new String(obj.valueOf());
    if (obj instanceof RegExp) return new RegExp(obj.valueOf());
    if (obj instanceof Date) return new Date(obj.valueOf());
    var cpObj = obj instanceof Array ? [] : {};
    for (var key in obj) cpObj[key] = myClone(obj[key]);
    return cpObj;
}
export function generateBig_1(){
    var str = [];
    for(var i=65;i<91;i++){
        str.push(String.fromCharCode(i));
    }
    return str;
}
//将秒转化为时分秒
export function formateSeconds(endTime){
    let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
    let min = 0// 初始化分
    let h =0// 初始化小时
    let result=''
    if(secondTime>60){//如果秒数大于60，将秒数转换成整数
      min=parseInt(secondTime/60)//获取分钟，除以60取整数，得到整数分钟
      secondTime=parseInt(secondTime%60)//获取秒数，秒数取佘，得到整数秒数
      if(min>60){//如果分钟大于60，将分钟转换成小时
        h=parseInt(min/60)//获取小时，获取分钟除以60，得到整数小时
        min=parseInt(min%60) //获取小时后取佘的分，获取分钟除以60取佘的分
      }
    }
   result=`${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}`
    return result 
}
//判断是否有网络
export function onLineNetWork (callback) {
    var img = new Image();
    //临时判断网络是否通畅
    img.src = 'https://wap-sz.aitestgo.com/favicon.ico?_t=' + Date.now();
    img.onload = function () {
        if (callback) callback(true)
    };
    img.onerror = function () {
        if (callback) callback(false)
    };
}
// 传入索引返回对应的大些字母
export function letter26To(index) {
    if(index!=0&&!index)return ''
    if(index<0)index = 0
    if(index>25)index = 25
    let letter_a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    let arr = letter_a.split('')
    return arr[index]
}
// 指定长度和基数
export function uuid2(len, radix) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [],
        i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join('');
}

export function getUrlKey(name){
    return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}

/**
 * 判断答题是否完整 mode:验证模式 ks宽松（默认） yg严格
 * ks:填空题50、文件题120 填写一个答案或上传一个文件即为已答
 * yg:填空题50、文件题120 填写或上传所有条数为已答
 * */
export function completeAllQuestions(jsonData,jsonDataJudge,questionInfo,mode='ks') {
    let flegs = []
    for (let i = 0; i < jsonData.length; i++) {
        const element = jsonData[i];
        let typeCode = Number(jsonDataJudge[i])
        switch(typeCode){
            case 10:
            case 11:
            case 12:
                element.selectIds? '':flegs.push(i)
                break;
            case 20:
                element.writeImgUrl? '':flegs.push(i)
                break;
            case 30:
                element.singAudioUrl? '':flegs.push(i)
                break;
            case 40:
                element.textVideoUrl? '':flegs.push(i)
                break;
            case 50:
                if(mode=='yg')
                (element.fillBlankVal.split("#@#").filter(child=>!isBlank(child)&&child!=' ').length)==(questionInfo[i].questionDto.detailInfo.blankList.length)?'':flegs.push(i)
                else
                element.fillBlankVal? '':flegs.push(i)
                break;
            case 60:
                element.rhythmBeatVal? '':flegs.push(i)
                break;
            case 61:
                element.rhythmSingAudioUrl? '':flegs.push(i)
                break;
            case 70:
                element.drawImgUrl? '':flegs.push(i)
                break;
            case 90:
                element.lineIds? '':flegs.push(i)
                break;
            case 100:
                element.originalityVal? '':flegs.push(i)
                break;
            case 110:
                element.viewVal.length>0? '':flegs.push(i)
                break;
            case 120:
                if(mode=='yg')
                questionInfo[i].fileNum==element.designUrl.split(',').filter(child=>!isBlank(child)&&child!=' ').length? '':flegs.push(i)
                else
                element.designUrl? '':flegs.push(i)
                break;
            case 130:
                element.designUrl? '':flegs.push(i)
                break;
            case 150:
                element.beatVal&&element.beatVal.length>0? '':flegs.push(i)
                break;
            case 170:
                element.dragVal&&element.dragVal.length>0? '':flegs.push(i)
                break;
            default:
                break;
        }
    }
    return flegs
}

export function getJson(url) {
    const timestamp = new Date().getTime(); // 获取当前时间戳
    const fullUrl = `${url}?t=${timestamp}`; // 拼接时间戳
    return fetch(fullUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        });
}

// 判断远程文件是否存在
export function checkRemoteFileExistence(url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === this.DONE) {
                if (this.status === 200) {
                    resolve(true); // 文件存在
                } else {
                    resolve(false); // 文件不存在
                }
            }
        };
        xhr.onerror = function () {
            resolve(false)
            // reject(new Error('请求出错'));
        };
        xhr.send();
    });
}
export function isBlank(data) {
    if (
      data == null ||
      data === 'null' ||
      data === '' ||
      data === undefined ||
      data === 'undefined' ||
      data === 'unknown'
    ) {
      return true
    } else {
      return false
    }
}

export default {
    menuListGet,
    ValidityOfIdentity,
    isObjNoKong,
    empty,
    getImgUrl,
    getVideoUrl,
    getAudioUrl,
    jube,
    getText,
    json_P,
    dealText,
    deepClone2,
    dealImg,
    dealAudio,
    dealVideo,
    checkHtml,
    foo_judge,
    getImageFileFromUrl,
    fmtDate,
    formatDateTime,
    intToChinese,
    delNoshelves,
    isVersion,
    toPercent,
    getFileSize,
    unsingNumber,
    timeStamp,
    fmtCountdown,
    renderTime,
    getRemainderTime,
    judgeMin0,
    testBW,
    topicTypeFilters,
    swapItems,
    inputNumber2,
    changeStr,
    HTMLDecode,
    acgType,
    mottoClone,
    generateBig_1,
    formateSeconds,
    onLineNetWork,
    letter26To,
    uuid2,
    completeAllQuestions,
    getUrlKey,
    getJson,
    checkRemoteFileExistence,
    isBlank
}


// WEBPACK FOOTER //
// ./src/lib/util.js